import { render } from "./CandidateCardGrid.vue?vue&type=template&id=110f0faa&scoped=true"
import script from "./CandidateCardGrid.vue?vue&type=script&lang=js"
export * from "./CandidateCardGrid.vue?vue&type=script&lang=js"

import "./CandidateCardGrid.vue?vue&type=style&index=0&id=110f0faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110f0faa"]])

export default __exports__